module.exports = __webpack_public_path__ + "static/img/282_TO8_2425_og.8c73ec1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/282_TO8_2425_og.jpg
// module id = UPcj
// module chunks = 0